// Modules
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

// CSS
import '_Asset/css/Admin/Page/admin.css'

// API
import { ReviewAprvApi, ReviewAprvSelfApi } from '_Route/Api';


const AdReviewAprvAppt = () => {

  const [guideStatus, setGuideStatus] = useState(true);
  const [aprvData, setAprvData] = useState([]) // 검토/승인자 목록
  const [myData, setMyData] = useState({ // 로그인된 유저의 검토/승인자 포함 정보 
    specifier: '',
    approver: '',
  }) 

  const sessionID = localStorage.getItem('memSessionID')
  const userScore = useSelector(state => state.authorityAcc.access_score);
  const userUid = useSelector(state => state.authorityAcc.uid);
  // const userRoles = useSelector(state => state.authorityAcc.roles);
  
  const [curAprv, setCurAprv] = useState('')
  const [curType, setCurType] = useState({name: '검토자', key: 'specifier'})
  const btnList = [
    {name: '검토자', key: 'specifier'},
    {name: '승인자', key: 'approver'},
  ]

  const onJSON = (data) => {
    try {
      const parseData = JSON.parse(data)
      let resData = '';
      parseData?.map((r, i) => {
        resData += (parseData.length === i + 1) ? r : r + ', '
      })
      return resData;
    }
    catch (err) {
      return data
    }
  }


  /* ========================================================================
  * Axios Reviewer / Approvaler
  ========================================================================*/
  // 나의 검토/승인자 목록 GET
  const myReviewAprv = () => {
    axios({
      url: ReviewAprvSelfApi,
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      params: {
        uid: userUid
      }
    })
    .then(res => {
      // console.log(res, "Reviewer / Applover Self List GET Success!")
      const r = res.data.result
      setMyData({...myData, specifier: r.specifier[0], approver: r.approver[0]})
    })
    .catch(err => { 
      console.error(err, "Reviewer / Applover Self List GET Error...")
    })
  }

  // 검토/승인자 목록 GET
  const getReviewAprvList = () => {
    axios({
      url : ReviewAprvApi,
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      params: {
        type: curType.key,
        is: 1,
      },
    })
    .then(res => {
      // console.log('Review/Approval List GET Success!', res)
      setCurAprv('')
      setAprvData(res.data.result.is_r1)
    })
    .catch(err => {
      console.error("Review/Approval List GET ERROR...", err);
    })
  }

  // 검토/승인자 지정 PUT
  const addReviewAprv = () => {
    axios({
      url: ReviewAprvApi,
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: {
        uid: curAprv.acc_uuid,
        name: curAprv.acc_name,
        email: curAprv.acc_email,
        type: curType.key,
      },
    })
    .then(res => {
      // console.log(res, 'Review/Approval List PUT Success!')
      alert(`${curAprv.acc_name}님으로 ${curType.name}를 지정하였습니다.`)
    })
    .catch(err => {
      // console.error(err, 'Review/Approval List PUT ERROR...')
      alert(err.response.data.message);
    })
    .finally(() => {
      myReviewAprv()
    })
  }

  useEffect(() => {
    myReviewAprv()
  }, [])
  
  useEffect(() => {
    getReviewAprvList()
  }, [curType])


  return (
    <>
      <div className="adContTitGroup">
        <h2>검토/승인자 지정</h2>
        <p>Home / 검토/승인 / 검토/승인자 지정 <button type="button" onClick={() => setGuideStatus(!guideStatus)}><i className="icofont-info-circle" /> 가이드 {guideStatus ? '접기' : '보기'} <i className={`icofont-rounded-${guideStatus ? 'up' : 'down'}`} /></button></p>

        <ul className={`subMsg ${guideStatus ? '' : 'off'}`}>
          <li>* 내부통제관리에 의한 검토자 및 승인자를 <span className="blueTxt">지정/수정</span>할 수 있습니다.</li>
          <li>* 지정 가능한 검토자/승인자 목록 관리는 <Link to="/admin/review-aprv/list" className="blueTxt" style={{textDecoration: 'underline'}}>해당 페이지</Link>에서 가능합니다.</li>
        </ul>
      </div>

      <div className="adContArea">
        <h3>나의 검토자/승인자</h3>

        <fieldset>
          <legend>검토자 / 승인자</legend>

          <div className="fieldGroup">
            <label>검토자<span className="redTxt">*</span></label>

            <div className="field full">
              <input type="text" className="input md round_10" value={myData?.specifier === undefined ? '지정된 검토자가 없습니다. 검토자를 지정해주세요.' : `${myData?.specifier.acc_name} - ${myData?.specifier.acc_email} - ${onJSON(myData?.specifier.acc_roles)}`} disabled />
            </div>
          </div>
          <div className="fieldGroup">
            <label>승인자<span className="redTxt">*</span></label>

            <div className="field full">
              <input type="text" className="input md round_10" value={myData?.approver === undefined ? '지정된 승인자가 없습니다. 승인자를 지정해주세요.' : `${myData?.approver.acc_name} - ${myData?.approver.acc_email} - ${onJSON(myData?.approver.acc_roles)}`} disabled />
            </div>
          </div>
        </fieldset>
      </div>

      <div className="adContArea">
        <h3>
          {curType.name} 지정
          <span className="textTab">
            {btnList.map((list, i) => 
              <button key={i} type="button" className={`btn xs ${curType.key === list.key ? 'sfrtBlue' : 'blue_edge'} round_10`} onClick={() => setCurType(list)}>{list.name}</button>
            )}
          </span>
        </h3>

        <fieldset>
          <legend>검토/승인자 지정</legend>

          <div className="fieldGroup">
            <label>{curType.name}를 선택해주세요.</label>

            <div className="divItemBox">
              <ul>
                {aprvData.length > 0 ?
                  aprvData.map((data, i) => 
                    <li key={i}>
                      <i className="icofont-arrow-right" />
                      <button type="button" onClick={() => setCurAprv(data)}>{data.acc_name} - {data.acc_email} - {onJSON(data.acc_roles)}</button>
                    </li>
                  )
                  :
                  <li className="noData">
                    <i className="icofont-warning-alt"></i>
                    <p>지정 가능한 {curType.name}가 존재하지 않습니다.</p>
                  </li>
                }
              </ul>
            </div>
          </div>

          <div className="fieldGroup">
            <label>{curType.name} 지정<span className="redTxt">*</span></label>

            <div className="field full">
              <input type="text" className="input md round_10" value={curAprv === '' ? '' : `${curAprv.acc_name} - ${curAprv.acc_email} - ${onJSON(curAprv.acc_roles)}`} disabled />
            </div>
          </div>
        </fieldset>

        <div className="btnArea">
          <button type="button" className="btn sm sfrtBlue round_10" onClick={addReviewAprv}>{curType.name} 지정 완료</button>
        </div>
      </div>
    </>
  )
}

export default AdReviewAprvAppt